export default "__VITE_ASSET__CdEigbo6__"